import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreDataClassificationsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-data-classifications',
	path: '/jira/core/projects/:projectKey/settings/data-classifications',
	exact: true,
};
